module.exports = __webpack_public_path__ + "img/logo.55915d1e.png";